<template>
  <div class="user-container" v-loading.fullscreen.lock="loading" :element-loading-text="loadingText">
    <el-page-header @back="goBack" content="账单导入"></el-page-header>
    <div class="step-1" v-if="step==1">
      <el-upload
        ref="upload"
        class="upload-demo"
        action="#"
        drag
        :on-change="handleChange"
        accept=".csv, .xls, .xlsx"
        :auto-upload="false">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          1. 支持上传csv,xls,xlsx文件，且不超过2MB <br>
          2. 目前支持支付宝，微信，汤圆记账，钱迹，网易有钱，叨叨记账，口袋记账账单的导入 <br>
          3. 数据默认导入到当前选择的账本，请确认您已经选择了正确的账本<br>
          4. 导入程序会自动匹配同名账户和分类。导入之前先按照之前的记账习惯创建好对应账户与分类，将会获得更好的导入效果哦
          </div>
      </el-upload>
    </div>
    <div class="step-2" v-if="step==2">
      <div class="total">共<span>{{tableData.length}}</span>条待导入账单</div>
      <el-table
        :data="tableData"
        stripe
        ref="multipleTable"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        max-height="550"
        style="width: 100%">
        <!-- max-height="400" -->
        <!-- <el-table-column
          type="selection"
          width="55">
        </el-table-column> -->
        <el-table-column
          prop="billingAt"
          label="时间"
          width="160">
          <template slot-scope="scope">
            {{scope.row.billingAt | date}}
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          width="60">
          <template slot-scope="scope">
            {{scope.row.type | type}}
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="金额"
          width="80">
          <template slot-scope="scope">
            {{scope.row.amount | amount}}
          </template>
        </el-table-column>
        <el-table-column
          prop="classification.name"
          label="分类"
          width="100">
        </el-table-column>
        <el-table-column
          prop="fromAccount.name"
          label="扣款账户"
          width="120">
        </el-table-column>
        <el-table-column
          prop="toAccount.name"
          label="收款账户"
          width="120">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="60">
          <template slot-scope="scope">
            <!-- <el-link size="small">修改</el-link> -->
            <el-link @click="deleteRow(scope.$index)" type="danger">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="btn-box">
        <el-button type="primary" v-on:click="importData">导 入</el-button>
      </div>
    </div>
    <div class="step-3" v-if="step==3">
      <img src="@/assets/success.svg" alt="成功">
      <div class="info">成功导入<span class="important">{{importCount}}</span>条账单到<span class="important">{{currentBook.name}}</span></div>
      <div>
        <el-link v-on:click="goBack" type="success"><i class="el-icon-back"></i>返回</el-link>
        <el-link v-on:click="step=1"><i class="el-icon-upload2"></i>继续导入</el-link>
      </div>
    </div>
    <el-dialog
      title="确认导入"
      :visible.sync="dialogVisible"
      width="30%">
      <div class="dialog">有<span class="important">{{tableData.length}}</span>条账单即将导入到<span class="important">{{currentBook.name}}</span>请确认是否导入。</div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small" plain>取 消</el-button>
        <el-button type="primary" @click="confirmImportData" size="small" plain>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style lang="scss" scope>
@import '@/scss/public.scss';

  .total {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .el-table td {
    font-size: 12px;
  }

  .btn-box {
    margin-top: 10px;
    text-align: right;
  }

  .dialog {
    font-size: 12px;
    .important {
      display: inline-block;
      padding: 0 5px;
      font-size: 18px;
      color: $color-type-transfer;
      font-weight: bold;
    }
  }

  .step-1 {
    .el-upload-dragger {
      border-radius: 0px;
    }
    .el-upload__tip {
      line-height: 22px;
    }
  }

  .step-2 {
    .total {
      font-size: 14px;

      span {
        display: inline-block;
        padding: 0 5px;
        color: $color-type-transfer;
      }
    }

    a {
      font-size: 12px;
      margin-right: 10px;
    }
  }

  .step-3 {
    background: $color-white;
    padding: 20px;
    width: 280px;
    text-align: center;
    font-size: 12px;
    img {
      height: 100px;
      margin-bottom: 20px;
    }
    .info {
      margin-bottom: 10px;
    }
    .important {
      display: inline-block;
      padding: 0 5px;
      color: $color-type-transfer;
      font-weight: bold;
    }
    .el-link {
      font-size: 12px;
      display: inline-block;
      padding: 0 5px;
      margin: 0 5px;
      
      i {
        margin-right: 2px;
      }
    }
  }
</style>

<script>
import { v4 as uuidv4 } from 'uuid';

import { Csv } from "@/utils/csv";
import { Xlsx } from "@/utils/xlsx";
import { Format } from "@/utils/format";
import { formatDate } from "@/utils/utils"

export default {
  name: 'Import',
  components: {
  },
   data() {
    return {
      step: 1,
      loading: false,
      loadingText: "",
      csvData: null,
      tableData: [],
      multipleSelection: [],
      classifications: [],
      outlayClassifications: [],
      incomeClassifications: [],
      accounts: [],
      importCount: 0,
      dialogVisible: false,
      deleteConfirm: false,
      IMPORT_LIMIT: 100,
    }
  },
  mounted() {
    this.getClassifications();
    this.getAccounts();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    handleChange(file) {
      this.loading = true;
      this.loadingText = "正在解析账单..."
      if (!/\.(xls|xlsx)$/.test(file.raw.name.toLowerCase())) {
        Csv(file.raw).then(data => {
          this.csvData = data;
          this.parseCsv();
        })
      } else {
        Xlsx(file.raw).then(data => {
          this.csvData = data;
          this.parseCsv();
        })
      }
      
    },
    deleteRow(index) {
      this.tableData.splice(index, 1);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    parseCsv() {
      if(this.classifications.length > 0 && this.csvData != null && this.csvData.data.length > 0) {
        this.tableData = Format(this.csvData, this.classifications, this.accounts);

        if(this.tableData == null || this.tableData.length == 0) {
          this.$message.error("未发现可导入账单");
          this.loading = false;
          return;
        }
        this.loading = false;
        this.step = 2;
      }
    },
    getClassifications(){
      this.$axios({
        method : "get",
        url : `/api/book/books/${this.currentBook.id}/classifications`,
      }).then(res => {
        if(res.status == 200 && res.data.status.code == 0) {
          this.classifications = res.data.result;
          this.classificationsTree();
          this.parseCsv();
        } else {
          this.$message.error('获取分类失败');
        }
      })
    },
    classificationsTree() {
      let outlayC = {};
      let incomeC = {};
      // 父分类
      this.classifications.forEach(v => {
        if(v.parent_id != 0) return true;
        if(v.type == 0) {
          v.value = v.id;
          v.label = v.name;
          outlayC[v.id] = v;
        } else if(v.type == 1) {
          v.value = v.id;
          v.label = v.name;
          incomeC[v.id] = v;
        }
      })
      // 子分类
      this.classifications.forEach(v => {
        if(v.parent_id == 0) return true;
        if(v.type == 0) {
          if(outlayC[v.parent_id] != undefined) {
            if(outlayC[v.parent_id].children == undefined) outlayC[v.parent_id].children = [];
            v.value = v.id;
            v.label = v.name;
            outlayC[v.parent_id].children.push(v);
          }
        } else if(v.type == 1) {
          if(incomeC[v.parent_id] != undefined) {
            if(incomeC[v.parent_id].children == undefined) incomeC[v.parent_id].children = [];
            v.value = v.id;
            v.label = v.name;
            incomeC[v.parent_id].children.push(v);
          }
        }
      })

      this.outlayClassifications = [];
      this.incomeClassifications = [];
      for(let key in outlayC) this.outlayClassifications.push(outlayC[key]);
      for(let key in incomeC) this.incomeClassifications.push(incomeC[key]);
    },
    getAccounts(){
      this.$axios({
        method : "get",
        url : `/api/book/books/${this.currentBook.id}/accounts`,
      }).then(res => {
        if(res.status == 200 && res.data.status.code == 0) {
          this.accounts = res.data.result;
        } else {
          this.$message.error('获取账户失败');
        }
      })
    },
    importData() {
      if(this.tableData.length == 0) {
        this.$message.error("未发现可导入账单");
          return;
      }
      this.dialogVisible = true;
    },
    confirmImportData() {
      this.dialogVisible = false;
      this.loading = true;
      this.loadingText = "正在导入账单...";
      this.importDataAction();
    },
    importDataAction() {
      let reqData = [];
      for(let i = 0; i < this.IMPORT_LIMIT; i++) {
        let t = this.tableData.shift();
        if(!t) break;
        reqData.push({
          action: 0,
          uuid: uuidv4(),
          type: t.type,
          amount: t.amount,
          from_account_id: t.fromAccount != null ? t.fromAccount.id : 0,
          to_account_id: t.toAccount != null ? t.toAccount.id : 0,
          classification_id: t.classification.id,
          remark: t.remark,
          billing_at: t.billingAt.getTime(),
          created_at: new Date().getTime(),
          updated_at: new Date().getTime()
        })
      }

      if(reqData.length == 0) {
        this.loading = false;
        this.step = 3;
      }

      this.$axios({
        method : "post",
        url : `/api/book/books/${this.currentBook.id}/records/push`,
        data: reqData,
        header: {'Content-Type': 'application/json'} 
      }).then(res => {
        if(res.status == 200 && res.data.status.code == 0) {
          this.importCount += reqData.length;
          if(reqData.length == this.IMPORT_LIMIT) {
            this.importDataAction();
          } else {
            this.loading = false;
            this.step = 3;
          }
        } else {
          this.$message.error('导入账单失败');
          this.loading = false;
          if(this.fullscreenLoading) this.fullscreenLoading.close();
          this.step = 1;
        }
      })
    }
  },
  computed: {
    currentBook() {
      return this.$store.state.currentBook;
    },
  },
  watch: {
    currentBook(newVal, oldVal) {
      if(newVal != oldVal) {
          this.getClassifications();
          this.getAccounts();
          this.step = 1;
          this.loading = false;
          this.tableData = [];
          this.csvData = null;
          this.multipleSelection = [];
          this.importCount = 0;
          this.dialogVisible = false;
      }
    },
  },
  filters: {
    date(value) {
      return formatDate(value, "yyyy-MM-dd hh:mm:ss")
    },
    type(value) {
      let typeStr = ["支出", "收入", "转账"]
      return typeStr[value];
    },
    amount(value) {
      return parseFloat(value).toFixed(2);
    }
  }
}
</script>